(function () {
  // 鶏雫 — ヘッダー高さとヒーロー高さを px で固定する。
  //
  // iOS ではスクロールに伴って URL バーが出入りし、vh / svh がそのたび変わる。
  // ヒーローの高さが変わると object-fit: cover の写真が拡大・縮小して見えるので、
  // 読み込み時の高さを px で持ち、幅が変わったときだけ測り直す。

  var lastW = 0;
  var MOBILE = 900;

  function syncHeader() {
    var h = document.querySelector('.ts-header');
    if (h) document.documentElement.style.setProperty('--ts-header-h', h.offsetHeight + 'px');
  }

  function syncHero() {
    var root = document.documentElement;
    if (window.innerWidth > MOBILE) {
      root.style.removeProperty('--ts-hero-h');
      return;
    }
    var header = document.querySelector('.ts-header');
    var hh = header ? header.offsetHeight : 0;
    var h = Math.round(window.innerHeight - hh);
    if (h < 420) h = 420;
    root.style.setProperty('--ts-hero-h', h + 'px');
  }

  function sync() {
    syncHeader();
    syncHero();
  }

  function onResize() {
    var w = window.innerWidth;
    if (w === lastW) return; // 高さだけの変化（URLバー）は無視
    lastW = w;
    sync();
  }

  function init() {
    lastW = window.innerWidth;
    sync();
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', function () {
      lastW = 0;
      setTimeout(onResize, 150);
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', sync);
  document.addEventListener('shopify:section:load', sync);
})();
